/* eslint-disable import/no-unresolved */
require('slick-carousel');

const processInclude = require('base/util');
const sideMenu = require('./account/menuSections');
const staticPages = require('./components/static');
const homeSlick = require('./components/homeSlick');
const bannerVideo = require('./components/bannerVideo');
const videoHtml5 = require('./components/videoHtml5');
const featuredProducts = require('./components/featuredProductsExperience');
const blogCarousel = require('./components/blogCarouselExperience');
const containerSlider = require('./components/containerSliderExperience');
const quickShopping = require('./components/quickShopping').assignQuickShopping;

$(document).ready(() => {
    processInclude(sideMenu);
    processInclude(staticPages);
    processInclude(featuredProducts);
    processInclude(containerSlider);
    processInclude(videoHtml5);
    processInclude(bannerVideo);
    processInclude(blogCarousel);

    if ($('.three-row-store-page').length <= 0) {
        processInclude(quickShopping);
    }
});

$(window).on('load', () => {
    processInclude(homeSlick);
});

require('./components/spinner');
